import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const AdminProtect = ({children}) => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isAuth, setIsAuth] = useState(localStorage.getItem('adminAuth') === 'true');

    const handleLogin = (e) => {
        e.preventDefault();
        const envUser = process.env.REACT_APP_ADMIN_USERNAME;
        const envPass = process.env.REACT_APP_ADMIN_PASSWORD;

        alert("envUser: " + envUser + ", envPass: " + envPass);
        if (username === envUser && password === envPass) {
            localStorage.setItem('adminAuth', 'true');
            setIsAuth(true);
            toast.success('Login Successful');
        } else {
            toast.error('Invalid credentials');
        }
    };

    if (isAuth) {
        return children;
    }

    return (
        <div 
            style={{ 
                position: 'fixed', 
                top: 0, left: 0, right: 0, bottom: 0, 
                width: '100vw', height: '100vh', 
                zIndex: 9999, 
                backgroundColor: '#f9fafb', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center' 
            }}
        >
            <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-md border border-gray-100" style={{ margin: '20px' }}>
                <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">Admin Login</h2>
                <form onSubmit={handleLogin}>
                    <div className="mb-5">
                        <label className="block text-gray-700 text-sm font-semibold mb-2">Username</label>
                        <input 
                            type="text" 
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-800 bg-white"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-8">
                        <label className="block text-gray-700 text-sm font-semibold mb-2">Password</label>
                        <input 
                            type="password" 
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-800 bg-white"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button 
                        type="submit" 
                        className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-blue-700 transition duration-300"
                    >
                        Login to Dashboard
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminProtect;